'use client'

// @ts-ignore
import first from 'lodash/first'
import {observer, useLocalObservable} from 'mobx-react'
import {usePathname, useSearchParams} from 'next/navigation'
import qs from 'qs'
import React from 'react'

import {CatalogContent} from '@/src/core/domain/entities/catalog'
import {PageType} from '@/src/core/domain/entities/page'

import {CsrFiltersProvider} from '@/src/features/catalog/filters-v2'

import {useStore} from '@/src/shared/hooks/useStore'
import {useRouter} from 'nextjs-toploader/app'
import {
  MobileFiltersVisibility,
  MobileFiltersVisibilityContext,
} from '@/src/features/catalog/filters-v2/containers/csr-filters-provider'

interface CatalogProvidersProps extends React.PropsWithChildren {}

export const CatalogProviders = observer(({children}: CatalogProvidersProps) => {
  const {pageData} = useStore<CatalogContent>()
  const type = pageData!.type
  const providers: React.ComponentType<React.PropsWithChildren>[] = []

  const catalogPageTypes = [
    PageType.CatalogProductList,
    PageType.BrandProductList,
    PageType.CatalogSales,
  ]

  if (catalogPageTypes.includes(type as ArrayItem<typeof catalogPageTypes>)) {
    providers.push(MobileProvider)
    providers.push(CsrFiltersProvider)
  }

  return providers.reduceRight((node, Provider) => {
    return <Provider>{node}</Provider>
  }, children)
})

const MobileProvider = observer(({children}: React.PropsWithChildren) => {
  const mobileFiltersVisibility = useLocalObservable(() => new MobileFiltersVisibility())

  return (
    <MobileFiltersVisibilityContext value={mobileFiltersVisibility}>
      {children}
    </MobileFiltersVisibilityContext>
  )
})

// TODO: типизировать сортировку
type CatalogSortOptions = {
  title: string
  value: string
  selected: boolean
}[]

export const useCatalogSort = (options: CatalogSortOptions) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const router = useRouter()

  const store = useStore<{
    // TODO: Типизация сортировки
    sort: {
      title: string
      value: string
      selected: boolean
    }[]
  }>()
  if (!store) throw Error('Not Wrap StoreContext')

  const {sort: sortVariants} = store.pageData!.content
  const sort =
    sortVariants.find((sortVariant: {value: string; selected: boolean}) => sortVariant.selected)
      ?.value || first(options)?.value

  const onChange = (sortValue: string) => {
    const currentSearchParams = qs.parse(searchParams.toString())

    const newQueryParams = {...currentSearchParams}
    newQueryParams.sort = sortValue

    const queryParamsText = qs.stringify(newQueryParams)

    if (queryParamsText === qs.stringify(currentSearchParams)) return

    router.replace(`${pathname}${queryParamsText && `?${queryParamsText}`}`)
  }
  return {sort, onChange}
}
